import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrievePlanzoneResourcesCountsRequestPending() {
      return getState().request.isPending;
    },
    isRetrievePlanzoneResourcesCountsRequestSuccess() {
      return getState().request.isSuccessful;
    },
    isRetrievePlanzoneResourcesCountsRequestFailure() {
      return getState().request.isFailure;
    },
    getPlanzoneResourcesCounts() {
      return getState().counts;
    },
  };
}

export { createSelector };
